export class ConflitoIdempotenciaError extends Error {
  readonly recursoId: string | null;

  constructor(mensagem: string, recursoId: string | null) {
    super(mensagem);
    this.name = 'ConflitoIdempotenciaError';
    this.recursoId = recursoId;
  }
}

export function extrairIdDoConflito(body: unknown, chave: string): string | null {
  if (typeof body !== 'object' || body === null) return null;
  const erro = (body as { error?: unknown }).error;
  if (typeof erro !== 'object' || erro === null) return null;
  const detalhes = (erro as { details?: unknown }).details;
  if (typeof detalhes !== 'object' || detalhes === null) return null;
  const valor = (detalhes as Record<string, unknown>)[chave];
  return typeof valor === 'string' && valor !== '' ? valor : null;
}
